import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ThemeToggleComponent } from './theme-toggle/theme-toggle.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ContentAreaComponent } from './content-area/content-area.component';
import { SharedModule } from '../shared/modules/shared.module';



@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ThemeToggleComponent,
    BreadcrumbComponent,
    ContentAreaComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    BreadcrumbComponent,
    ContentAreaComponent
  ],
  imports: [
    SharedModule,
    RouterModule
  ]
})
export class LayoutModule { }
